export const getQueryKey = (containerId: string) => ['containers', containerId];
